import { createContext, useContext, useMemo } from "react";
import { translate, format } from "../translations";

// Web tarafı şimdilik yalnızca Latin alfabesinde. Osmanlıca script modu
// kaldırıldı; geri eklenmesi gerekirse burada bir mod state'i ve
// translate(key, mode) ikinci parametresi yeterli olur.
const ScriptModeContext = createContext(null);

export function ScriptModeProvider({ children }) {
  const value = useMemo(() => {
    const t = (key, params) => {
      const raw = translate(key);
      return params ? format(raw, params) : raw;
    };
    return { t };
  }, []);

  return <ScriptModeContext.Provider value={value}>{children}</ScriptModeContext.Provider>;
}

export function useScriptMode() {
  const ctx = useContext(ScriptModeContext);
  if (!ctx) throw new Error("useScriptMode must be used within ScriptModeProvider");
  return ctx;
}
